import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { delay, map } from "rxjs/operators";
import { BASE_API_URL } from "../../../../core/environment.tokens";
import { BulkProjectResponse } from "./bulk-project-response.model";

export interface IUploadObject {
  presignedURL: string;
  fileName: string;
}

@Injectable({
  providedIn: "root",
})
export class BulkProjectUploadService {
  projectsResponse = new BehaviorSubject<BulkProjectResponse>(new BulkProjectResponse());

  constructor(
    @Inject(BASE_API_URL)
    private readonly baseApiUrl: string,
    private readonly http: HttpClient
  ) { }

  getPresignedURL(payload: string): Observable<IUploadObject> {
    const url = `${this.baseApiUrl}presignedurl`;

    return this.http.post(url, payload, { headers: new HttpHeaders({ "Content-Type": "application/json" }) })
      .pipe(map((response: any) => response as IUploadObject));
  }

  uploadFile(url: string, file: File): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        this.http.put(url, file).toPromise().then(() => resolve(true)).catch(reject);
      } catch (e) {
        reject(e);
      }
    });
  }

  bulkValidate(fileLocation: string): Observable<HttpResponse<BulkProjectResponse>> {
    // TODO(AD-1731): Replace this mocked response with the real validation endpoint once the backend is ready.
    // The uploaded file location returned from the pre-signed URL flow should be passed to the endpoint, e.g.:
    //   const url = `${this.baseApiUrl}project/bulkvalidate`;
    //   return this.http.post(url, { fileLocation }, { observe: "response" }) as Observable<HttpResponse<BulkProjectResponse>>;
    const mockBody = new BulkProjectResponse({
      totalProjectsPassed: 0,
      totalProjectsFailed: 0,
      fileContent: "",
    });

    return of(new HttpResponse<BulkProjectResponse>({ status: 200, body: mockBody })).pipe(delay(1500));
  }
}
